<template>
  <div style="" class="father">
    <wty-permission
      v-if="wtypermiss_show"
      :who="'permission'"
      :perssionData="perssionData"
      :tableList="tableList"
      :tableClumn="tableClumn"
    ></wty-permission>
  </div>
</template>
<script>
import wtyPermission from "@/components/wty-permission.vue";
import { getPermissList, baseinfoListAccount } from "@/api/service.js";
export default {
  name: "Permission",
  components: { wtyPermission },
  data() {
    return {
      tableList: [],
      perssionData: {},
      wtypermiss_show: true,
      tableClumn: [
        {
          prop: "account_name",
          align: "center",
          label: "名字",
          width: "200",
          fixed: "left"
        },
        {
          prop: "account_id",
          align: "center",
          label: "id",
          width: "150",
          fixed: "left"
        }
      ]
    };
  },
  async mounted() {
    this.wtypermiss_show = false;
    const res = await getPermissList();
    this.perssionData = res;

    const result = await baseinfoListAccount();
    this.tableList = result;
    console.log("result", result);
    this.wtypermiss_show = true;
  }
};
</script>
<style scoped>
.father {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden !important;
  padding-top:10px ;
}
</style>
